import React, { useEffect, useRef } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";

const Link = Quill.import("formats/link");

// @ts-ignore
class CustomLink extends Link {
  static create(value: any) {
    const node = super.create(value);
    node.setAttribute("target", "_self");
    return node;
  }
}

// @ts-ignore
Quill.register(CustomLink, true);

type Props = {
  value?: string;
  onChange?: (html: string) => void;
};

export const QuillEditor = ({ value = "", onChange }: Props) => {
  const quillRef = useRef<ReactQuill | null>(null);
  const isMountedRef = useRef(false);

  useEffect(() => {
    const quill = quillRef.current?.getEditor();
    if (!quill) return;
    if (isMountedRef.current) return;

    if (value) {
      // react-quill бандлит Quill 1.3.7, а его setSelection() дёргает
      // root.focus() без preventScroll — браузер скроллит страницу к редактору,
      // если тот стоит не в начале формы. Восстанавливаем позицию скролла вручную.
      const { scrollX, scrollY } = window;
      quill.clipboard.dangerouslyPasteHTML(value);
      window.scrollTo(scrollX, scrollY);
    } else {
      quill.setText("");
    }

    isMountedRef.current = true;
  }, [value]);

  const handleChange = (content: string, _delta: any, source: string) => {
    if (source !== "user") return;
    onChange?.(content);
  };

  return (
    <ReactQuill
      ref={quillRef}
      theme="snow"
      defaultValue=""
      onChange={handleChange}
      modules={{
        toolbar: [
          [{ header: [1, 2, false] }],
          ["bold", "italic", "underline", "strike", "blockquote"],
          [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
          ["link"],
          ["clean"],
        ],
        clipboard: {
          matchVisual: false,
        },
      }}
      formats={[
        "header",
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "list",
        "bullet",
        "indent",
        "link",
      ]}
    />
  );
};